import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) {}


  ngOnInit(): void {
    this.titleService.setTitle('MISK - Satff');
  }

}
